import { render, staticRenderFns } from "./loading.view.vue?vue&type=template&id=a56e3cf4&scoped=true"
import script from "./loading.view.vue?vue&type=script&lang=js"
export * from "./loading.view.vue?vue&type=script&lang=js"
import style0 from "./loading.view.vue?vue&type=style&index=0&id=a56e3cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56e3cf4",
  null
  
)

export default component.exports